import dynamic from 'next/dynamic';
import { RelatedServicesProps } from './RelatedServicesComponent';

const RelatedServicesComponent = dynamic(() => import('./RelatedServicesComponent'), {
    ssr: false,
});

export default function RelatedServicesComponentRender({
    services,
    currentServiceKey,
}: RelatedServicesProps) {
    return <RelatedServicesComponent services={services} currentServiceKey={currentServiceKey} />;
}
